<template>
  <v-container>
    <wc-data-box
      title='Project Estimates'
      :titleIcon='$store.state.icons.modules.estimates.icon'
      :titleIconColor='$store.state.icons.modules.estimates.color'
      showHelp
      helpText='These are the estimates connected to this project.'
    >
    <!-- eventually want to be able to create service estimates from here -->
      <v-data-table
        dense
        :items='estimates'
        :headers='headers'
        :search='search'
        :loading='isLoading'
        sort-by='estimate_date'
        sort-desc
        @click:row='openEstimate'
      >
        <template v-slot:item.name='{ item }'>
          {{ item.name }}
          <v-icon v-if='item.is_comm' class='mt-n1' right small color='primary'>mdi-domain</v-icon>
          <wc-archived v-if='item.archived'></wc-archived>
        </template>
        <template v-slot:item.estimate_date='{ item }'>
          {{ item.estimate_date | shortDate }}
        </template>
        <template v-slot:item.project_obj.site_address='{ item }'>
          {{ item.project_obj.site_address }}
          <span v-if='item.site_city'>, {{ item.site_city }}</span>
        </template>
        <template v-slot:item.status_display='{ item }'>
          <wc-estimate-type left :estimate='item' xSmall></wc-estimate-type>
          <wc-estimate-status :estimate='item' xSmall showTooltip></wc-estimate-status>
        </template>
        <template v-slot:item.division_obj.division='{ item }'>
          <wc-division-nai :division_obj='item.division_obj'></wc-division-nai>
        </template>
      </v-data-table>
      </wc-data-box>
  </v-container>
</template>

<script>
import estimateAPI from '@/modules/estimates/api/estimates'
import WCEstimateStatus from '@/components/chips/WCEstimateStatus'
import WCEstimateType from '@/components/chips/WCEstimateType'

export default {
  name: 'project-estimates',
  data: () => ({
    isLoading: true,
    estimates: [],
    search: '',
    headers: [
      { text: 'Date', value: 'estimate_date', width: '120' },
      { text: 'Division', value: 'division_obj.division', width: '120' },
      { text: 'Name', value: 'name' },
      { text: 'Site Address', value: 'project_obj.site_address' },
      { text: 'Status', value: 'status_display', align: 'center' }
    ]
  }),
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.estimates = await estimateAPI.getProjectEstimates(this.$route.params.id)
      this.isLoading = false
    },
    openEstimate (obj) {
      this.$router.push({ name: obj.division_obj.division + 'Estimate', params: { id: obj.id } })
    }
  },
  components: {
    'wc-estimate-status': WCEstimateStatus,
    'wc-estimate-type': WCEstimateType
  }
}
</script>
